{
  "heading": "Du har ikke tilgang til Skoghub",
  "message": "Det ser ut til at du ikke har de nødvendige rettighetene for å se innholdet her.",
  "messageContact": "Kontakt administrator på it-support@viken.skog.no.",
  "messageRefresh": "Har du fått tilgang? Last inn siden på nytt for å prøve igjen.",
  "contactAdmin": "Kontakt administrator",
  "logout": "Logg ut"
}
